export const ENV_LOCAL = 'local' as const
export const ENV_STAGING = 'staging' as const
export const ENV_PRODUCTION = 'production' as const

export type Environment = typeof ENV_LOCAL | typeof ENV_STAGING | typeof ENV_PRODUCTION
export const ENVIRONMENTS: Record<
  Environment,
  { label: string; color: string; titlePrefix?: string; favicon?: string }
> = {
  [ENV_LOCAL]: {
    label: 'Local',
    color: 'bg-blue-500',
    titlePrefix: '[local] ',
    favicon: '/favicon-local.png'
  },
  [ENV_STAGING]: {
    label: 'Stage',
    color: 'bg-green-500',
    titlePrefix: '[stg] ',
    favicon: '/favicon-stg.png'
  },
  [ENV_PRODUCTION]: {
    label: '',
    color: ''
  }
}
